export const autoplayConfig = {
  delay: 8000,
  disableOnInteraction: false,
};

export const paginationConfig = {
  dynamicBullets: false,
  bulletActiveClass: 'swiper-pagination-bullet-active banner-pagination-bullet-active',
  bulletClass: 'swiper-pagination-bullet banner-pagination-bullet',
} 

export const freeModeConfig = {
  enabled: true,
  momentum: true,
  momentumRatio: 0.2,
  sticky: true,
  momentumBounce: false,
};